const preferenceKey = ["EMAIL_VER", "EMAIL_PLAN_EX"];

export default preferenceKey;